import { render, staticRenderFns } from "./we-advantage.vue?vue&type=template&id=11b21527&scoped=true"
import script from "./we-advantage.vue?vue&type=script&lang=js"
export * from "./we-advantage.vue?vue&type=script&lang=js"
import style0 from "./we-advantage.vue?vue&type=style&index=0&id=11b21527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b21527",
  null
  
)

export default component.exports